import { Box, Text, Flex, ListItem, UnorderedList } from "@chakra-ui/react";

const renderLegend = (props: any) => {
  const { payload } = props;
  return (
    <UnorderedList
      w="100%"
      listStyleType="none"
      m="0"
      p="0"
      display="flex"
      justifyContent="center"
    >
      {payload.map((entry: any, index: number) => (
        <ListItem key={`item-${index}`} my="20px" mr="14px">
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Box
                bg={entry.color}
                width="14px"
                height="14px"
                borderRadius="4px"
                mr="8px"
              ></Box>
              <Text color="#171B1E" fontWeight="500" fontSize="14px">
                {entry.value}
              </Text>
            </Flex>
          </Flex>
        </ListItem>
      ))}
    </UnorderedList>
  );
};

export default renderLegend;
